import type { ReactNode } from "react";

import { PageTitle } from "./PageTitle";
import { ScrollScreen } from "./ScrollScreen";
import { Stack } from "./Stack";

export function ProtectedScreen({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <ScrollScreen>
      <Stack gap="lg">
        <PageTitle title={title} subtitle={subtitle} />
        <Stack gap="lg">{children}</Stack>
      </Stack>
    </ScrollScreen>
  );
}
